module.exports = __webpack_public_path__ + "assets/img/arrow-right.6531f3da.svg";